import API from "../config/api.js";

export const GrnService = {
  getBranches() {
    return API.get("/api/inventory/branches");
  },

  getSuppliers() {
    return API.get("/api/inventory/suppliers");
  },

  getBatchList(id) {
    return API.get(`/api/grn/batches/list/${id}`);
  },
  getBatchList2(search) {
    return API.get(`/api/batch/list/se=${search}`);
  },

  getPurchaseOrders() {
    return API.get(`/api/purchaseorder/ponumber`);
  },

  getPurchaseOrdersBySearch(query) {
    return API.get(`/api/purchaseorder/search`, { params: { query } });
  },

  //this function will get po items
  async getItemsByPoNumber(po_number) {
    console.log("po_number in service");
    try {
      const response = await API.get(
        `/api/purchaseorder/getitems/${po_number}`,
      );
      console.log("data : ", response.data);
      return response.data; // Return items for the given PO number
    } catch (error) {
      console.error("Error fetching items by PO number:", error);
      throw error;
    }
  },

  async getItemsByGrnNumber(grn_number) {
    console.log("grn_number in service", grn_number);
    try {
      const response = await API.get(`/api/grn/info/items/${grn_number}`);
      console.log("item data : ", response.data);
      return response.data.data; // Return items for the given grn_number
    } catch (error) {
      console.error("Error fetching items by PO number:", error);
      throw error;
    }
  },

  async createGrn(formData) {
    try {
      const response = await API.post("/api/grn/create", formData);
      return response.data;
    } catch (error) {
      console.error("Error creating GRN:", error);
      throw error; // Rethrow error to handle it in the component
    }
  },

  getGrnList(search, page = 1) {
    return API.get(`/api/grn/list/se=${search}`, { params: { page: page } });
  },

  async getGrnDetails(uuid) {
    try {
      console.log("grn details uuid : ", uuid);
      const response = await API.get(`/api/grn/info/${uuid}`);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching GRN details:", error);
      throw error;
    }
  },

  async updateGrn(grn_number, formData) {
    try {
      console.log("Updating GRN with data:", formData);
      const response = await API.put(
        `/api/grn/info/update/${grn_number}`,
        formData,
      );
      console.log("Response from API:", response);

      // Return the response data if the update was successful
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Unexpected response status: " + response.status);
      }
    } catch (error) {
      // Improved error logging
      console.error("Error updating GRN:", error);

      if (error.response) {
        console.error("API Response Error:", error.response.data);
      }
      throw error;
    }
  },

  async dropMember(uuid) {
    const response = await API.delete(`api/grn/delete/${uuid}`);
    return response.data;
  },

  
};
